'use es6';

import { createSelector } from 'reselect';
const getPortalMigration = state => typeof state.get === 'function' ? state.get('portalMigration') : state.portalMigration;
export const getPortalMigrationStatus = createSelector(getPortalMigration, portalMigration => portalMigration.statusCategory);
export const getPortalMigrationStartDate = createSelector(getPortalMigration, portalMigration => portalMigration.readOnlyStartDate);
export const getPortalMigrationEndDate = createSelector(getPortalMigration, portalMigration => portalMigration.readOnlyEndDate);
export const getPortalMigrationNewHoistingHublet = createSelector(getPortalMigration, portalMigration => portalMigration.toHublet);